import _ from 'lodash';
import alertify from 'alertifyjs';

export const alerts = {
    methods : {
        logError : function (error, msg) {
            if (msg) {
                // console.error(msg, error);
                this.errorMsg(msg);
            } else {
                // console.error('An error occured', error);
            }
        },
        errorMsg : function (error) {
            this.showAlert(error, 'error');
        },
        warningMsg : function (msg) {
            this.showAlert(msg, 'warning');
        },
        successMsg : function (msg) {
            this.showAlert(msg, 'success');
        },
        infoMsg : function (msg) {
            this.showAlert(msg, 'info');
        },
        helpMsg : function (msg) {
            alertify.alert(msg).set('basic', true);
        },
        showAlert : function (text, type) {
            alertify.set('notifier', 'position', 'top-right');
            alertify.notify(text, type, 8);
        },
        hideAlerts : function () {
            alertify.dismissAll();
        },
        axiosError : function (err) {
            var msg = 'There was a problem processing the request';
            if (err.response) {
                if (err.response.data.errors) {
                    msg = 'There was a problem with the data you provided, please check and resend';
                    let self = this;
                    _.each(err.response.data.errors, function (e) {
                        _.each(e, function (msg) {
                            self.error(msg);
                        });
                    });
                }
                // console.log('API Returned status code:', err.response.status);
                if (err.response.status == 401) {
                     // redirect to login page
                     this.logerror('You are not authenticated, please login again', err);
                     window.replace('/logout');
                     return;
                } else if (err.response.status == 403) {
                    msg = 'You do not have permission to view some of the data you have requested';
                } else if (err.response.status == 404) {
                    msg = 'We could not find the data you have requested.';
                } else if (err.response.status == 405) {
                    msg = 'The request was sent using the wrong method';
                } else if (err.response.status == 408) {
                    msg = 'The request timed out';
                } else if (err.response.status == 429) {
                    msg = 'You have sent too many requests';
                }
            }
            this.logError(err, msg);
        }
    }
}